// Single source of truth for the Premium / Lifetime feature lists shown on
// both the public landing pricing section and the in-app /plans page.
//
// Premium and Lifetime share EXACTLY the same 15 features. The only thing
// that differs is item #13 (storage: 10 GB vs 25 GB). Keeping this list in
// one file prevents the landing and /plans from drifting out of sync.
//
// Each entry is an i18n key resolved at render time via t(key).

const SHARED_KEYS_BEFORE_STORAGE = [
  "feat_vault_unlimited",          // 1
  "feat_messages_unlimited",       // 2
  "feat_heirs_unlimited",          // 3
  "feat_contacts_unlimited",       // 4
  "feat_assets_unlimited_v2",      // 5  (incluye seguros)
  "feat_pol_configurable",         // 6
  "feat_will",                     // 7
  "feat_ice_full",                 // 8
  "feat_ice_pdf",                  // 9
  "feat_share",                    // 10
  "feat_share_panel",              // 11
  "feat_executor_checklist",       // 12
];

const SHARED_KEYS_AFTER_STORAGE = [
  "feat_languages",                // 14
  "feat_export_gdpr",              // 15
];

/**
 * Returns the ordered list of 15 i18n keys to render for a given plan.
 * @param {"premium"|"lifetime"} plan
 */
export function getPlanFeatureKeys(plan) {
  const storageKey = plan === "lifetime" ? "feat_storage_lifetime" : "feat_storage_premium";
  return [
    ...SHARED_KEYS_BEFORE_STORAGE,
    storageKey,                    // 13
    ...SHARED_KEYS_AFTER_STORAGE,
  ];
}
